// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RO3P9"};